/**
 * Defence and contact clauses — what answered the blow.
 *
 * AoD §12.1's rule is that the thing that stopped a blow is *named*. "The blow
 * misses" is what a log writes when nobody modelled the answer; a fighter who
 * gave ground, turned it on a shield, or found iron under the wool is a
 * different fight and should read like one.
 *
 * `armour` is not a defence anybody made — it is the blow arriving and finding
 * mail. It renders in the defence slot because that is what the reader needs to
 * know at that moment, and because *"the axe turns on his byrnie"* is the line
 * that makes armour feel like armour rather than like arithmetic.
 */
export const DEFENCES = {
    parry: [
        '{victim} turns it aside.',
        '{victim} catches the blow and throws it wide.',
        '{victim} beats {weapon} away.',
    ],
    dodge: [
        '{victim} twists away from it.',
        '{victim} dodges back; the blow passes harmlessly by.',
        'It goes by {victim} by a hand’s breadth.',
    ],
    'give-ground': [
        '{victim} gives ground and it falls short.',
        '{victim} backs out of the reach of {weapon}.',
    ],
    armour: [
        '{weapon} turns on {armour}.',
        '{weapon} finds {armour} over {victim}’s {part} and stops there.',
        '{armour} takes the blow and holds.',
    ],
};
/**
 * Contact clauses — the blow got through. Split two ways.
 *
 * By **weight**, because a level-0 hit that raises a welt and a level-4 hit that
 * breaks a thigh should not share an opening line. And by whether the blow
 * passed *through* something on the way in, which is what the clothing layer in
 * `armour.ts` exists for: everybody in the valley is wearing wool worth no
 * armour value whatsoever, purely so the log can name what the blade opened
 * before it reached the man.
 */
export const CONTACTS = {
    solid: ['The blow lands.', 'It gets through.', 'It goes home.'],
    glancing: [
        'It grazes {victim}.',
        'It catches {victim} a glancing blow.',
        'It scrapes past and does little.',
    ],
    'solid-through': [
        'It goes through {armour} and into {them}.',
        '{weapon} opens {armour} and does not stop there.',
        '{armour} parts, and the blow goes home.',
    ],
    'glancing-through': [
        'It drags across {armour} and catches {victim} beneath.',
        '{armour} takes most of it, and not all of it.',
        'It snags {armour} and scrapes past.',
    ],
};
//# sourceMappingURL=defences.js.map